"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TargetdrgsController = function TargetdrgsController($scope, DTOptionsBuilder, DTColumnBuilder, USER, CONST, materialButtons, $rootScope, FunctionService) {
  _classCallCheck(this, TargetdrgsController);

  this.datatableApi;
  this.user = USER;
  this.name = "Target DRGs";
  this.locale = "en-au";
  this.url = WEBSERVICEURL + "/dataagility/api/service.targetdrgs/targetdrgs";
  this.initUrl = this.url;

  materialButtons.render();
  materialButtons.processing();

  $scope.initCallback = function () {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.functionSettings = response.functionSettings;

    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
        return x.mData === "drgVersion";
      });
      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
    }
  });

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    },
    url: $scope.vm.initUrl,
    type: "GET",
    error: function error(xhr, _error, thrown) {
      if (thrown == "Unauthorized") window.location.replace(window.location.origin + "/login");
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]).withColumnFilter({
    aoColumns: [{ type: "text" }, { type: "text" }, { type: "text" }]
  });

  this.dtColumns = [DTColumnBuilder.newColumn("DRGCode").withTitle("DRG Code").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG Version").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("label").withTitle("DRG Type").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("comments").withTitle("Alert / Notes").withClass("mdl-data-table__cell--non-numeric").withOption("defaultContent", ""), DTColumnBuilder.newColumn("descriptions").withTitle("Speciality").withClass("mdl-data-table__cell--non-numeric").withOption("defaultContent", "")];

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }
};

exports.default = TargetdrgsController;


// WEBPACK FOOTER //
// ./client/app/common/reports/targetdrgs/targetdrgs.controller.js